import useTranslation from 'next-translate/useTranslation'
import useRegionCode from '@/helpers/useRegionCode'
import EpsLogo from '@/icons/eps-logo.svg'
import UnzerDirectBankTransferLogo from '@/icons/unzer-direct-bank-transfer-logo.svg'
import { ERegionCode } from '@/types/gql/graphql'
import { cn } from '@/utils/cn'
import PaypalIcon from './assets/paypal.svg'

interface Props {
  className?: string
}

export function AvailablePayoutOptions({ className }: Props) {
  const { t } = useTranslation('checkout')
  const regionCode = useRegionCode()

  return (
    <div
      className={cn(
        'bg-fill-brand-tertiary border border-secondary rounded-b-xl text-s flex flex-row items-center gap-3',
        className,
      )}
    >
      <span className="text-secondary">
        {t('payout_options.available_methods')}
      </span>
      <span className="font-semibold text-primary">
        {t('payout_options.cash')}
      </span>
      {regionCode === ERegionCode.De ? (
        <UnzerDirectBankTransferLogo height="15px" />
      ) : (
        <EpsLogo height="15px" className="-mb-px" />
      )}
      <PaypalIcon className="-mb-[3px]" />
    </div>
  )
}
